<app-select
  [appearance]="taskListMode === TaskListModeEnum.Search ? 'outline' : 'fill'"
  [control]="sortControl"
  [items]="sortTypes"
  [labelKey]="'inbox/task-list/order-by'"
  [panelClass]="'panel-content-width'"
  [formFieldClass]="'no-vertical-padding'"
  [matTooltip]="tooltipTxt"
  [matTooltipDisabled]="sortControl.enabled">
</app-select>
